<template>
  <Widget :class="`${el}__widget`">
    <div :class="`${el}__widgetBackground`">
      <Picture
        :img="`assets/images/care-profiles/${$matchMedia.l ? 'desktop' : 'mobile'}/profiles-bg`"
      />
    </div>
    <Copy
      v-if="error"
      centered
      bold
      color="supportDanger"
      size="m"
      :staticClass="`${el}__widgetErrorMsg`"
    >
      {{ $t('careProfile.form.error.generics') }}
    </Copy>
    <div v-if="isLoading" :class="`${el}__spinner`">
      <Spinner color="primaryBlue" size="l" />
    </div>
    <div v-else :class="`${el}__widgetContent`">
      <div :class="`${el}__widgetTitle`">
        <div :class="`${el}__widgetRow`">
          <Copy size="s" element="div" color="tertiaryLight" bold>
            {{
              $t('careProfile.careProfile.headline').toUpperCase() +
              ($matchMedia.l && !done ? ':' : '')
            }}
          </Copy>
          <Copy
            v-if="$matchMedia.l && !done"
            size="s"
            element="div"
            color="primaryBlue"
            staticClass="u-margin__left--1"
            bold
          >
            {{ $t('careProfile.widget.subheadline', { percentage: percentage }) }}
          </Copy>
        </div>
        <Headline size="m" responsive noMargin>
          {{ profileName }}
        </Headline>
      </div>

      <div :class="`${el}__widgetImageWrapper`">
        <svg :class="`${el}__widgetGradient`" viewBox="0 0 20 20" v-if="!done">
          <circle
            :class="`${el}__widgetGradientProgress ${el}__widgetGradientProgress--white`"
            :r="10"
            :cx="10"
            :cy="10"
          />
          <circle
            :class="`${el}__widgetGradientProgress`"
            :r="10"
            :cx="10"
            :cy="10"
            :stroke-dasharray="20 * Math.PI"
            :stroke-dashoffset="20 * Math.PI * (1 - percentage / 100)"
          />
        </svg>
        <div :class="`${el}__widgetGradientProgressText  ${el}__initialsCircleText`" v-if="!done">
          {{ profileInitials }}
        </div>

        <div :class="`${el}__initialsCircle  ${el}__initialsCircleText`" v-else>
          {{ profileInitials }}
        </div>

        <Icon
          v-if="profileInitials === ''"
          :class="`${el}__initialsIcon`"
          name="folder-user-line"
          color="primaryBlue"
          size="xxl"
        />
      </div>

      <Copy
        v-if="!$matchMedia.l && !done"
        size="s"
        element="div"
        color="primaryBlue"
        staticClass="u-margin__bottom--3"
        bold
        centered
      >
        {{ $t('careProfile.widget.subheadline', { percentage: percentage }) }}
      </Copy>

      <div :class="`${el}__widgetLink`">
        <Button
          type="secondary"
          :href="ROUTE_CARE_PROFILES"
          :label="
            done
              ? $t('careProfile.widget.button.label.done')
              : $t('careProfile.widget.button.label.undone')
          "
          @click="
            $emit(
              'onTrackingClick',
              '_btn-' +
                (done
                  ? $t('careProfile.widget.button.label.done')
                  : $t('careProfile.widget.button.label.undone'))
            )
          "
          small
        />
      </div>
    </div>
  </Widget>
</template>

<script>
import initialsMixin from '@/mixins/initials';
import Copy from '@/objects/Copy/';
import Button from '@/objects/Button/';
import Headline from '@/objects/Headline';
import Widget from '@/objects/Widget';
import Picture from '@/objects/Picture';

import { ROUTE_API_GET_CARE_PROFILE_DATA } from '@/constants/apiRoutes';
import { ROUTE_CARE_PROFILES } from '@/constants/routes';
import Vue from 'vue';
import Spinner from '@/objects/Spinner/Spinner';
import Icon from '@/objects/Icon/Icon';

export default {
  name: 'CareProfilesWidget',
  components: { Icon, Spinner, Widget, Headline, Button, Copy, Picture },
  props: {},
  mixins: [initialsMixin],

  created() {
    this.getCareProfileData();
  },

  data() {
    return {
      isLoading: true,
      percentage: 0,
      done: false,
      profileName: '',
      profileInitials: '',
      profileData: {
        firstname: '',
        lastname: '',
      },
      error: false,
      ROUTE_CARE_PROFILES,
      el: 'v-careProfiles',
    };
  },

  methods: {
    getCareProfileData() {
      Vue.axios
        .post(ROUTE_API_GET_CARE_PROFILE_DATA)
        .then((response) => {
          this.setData(response.data.careProfile);
        })
        .catch(() => {
          this.error = true;
        });
    },

    setData(object) {
      this.percentage = this.calculatePercentage(object);

      if (this.percentage === 100) {
        this.done = true;
      }

      this.profileData.firstname = object.firstname ? object.firstname : '';
      this.profileData.lastname = object.lastname ? object.lastname : '';

      if (this.profileData.firstname !== '' || this.profileData.lastname !== '') {
        this.profileName = this.profileData.firstname + ' ' + this.profileData.lastname;
      } else {
        this.profileName = this.$t('careProfile.careProfile.headline') + ' #1';
      }
      if (this.profileData.isProfileOwner === 1) {
        this.profileInitials = this.initials;
      } else {
        this.profileInitials = this.getInitials(this.profileData);
      }
      this.error = false;
      this.isLoading = false;
    },

    calculatePercentage(object) {
      let profileData = object;
      delete profileData.isProfileOwner;
      delete profileData.unregisteredUuid;
      delete profileData.createdAt;

      if (profileData.gender === 0) {
        profileData.gender = null;
      }

      const total = Object.keys(profileData).length;
      let filled = 0;

      Object.keys(profileData).map((i) => {
        if (profileData[i] !== null && profileData[i] !== '') {
          filled++;
        }
      });

      return Math.round((100 * filled) / total);
    },
  },
};
</script>
